import { motion } from 'framer-motion'
import clsx from 'clsx'

const GlassCard = ({ 
  children, 
  className, 
  hover = true,
  onClick,
  ...props 
}) => {
  return (
    <motion.div
      className={clsx(
        'glass-card p-6',
        onClick && 'cursor-pointer',
        className
      )}
      onClick={onClick}
      whileHover={hover ? { scale: 1.02, y: -5 } : {}}
      whileTap={onClick ? { scale: 0.98 } : {}}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {children}
    </motion.div>
  )
}

export default GlassCard